import activeOrg from './activeOrganization'
import articleManage from './articleManage'
import base from './base'
import bulletinBoard from './bulletinBoard'
import dataAnalysis from './dataAnalysis'
import enums from './enums'
import fileManage from './fileManage'
import help from './help'
import login from './login'
import setting from './setting'
import software from './software'
import tips from './tips'
import whitelist from './whitelist'

export default {
  login,
  ...base,
  tips,
  articleManage,
  setting,
  fileManage,
  dataAnalysis,
  help,
  software,
  whitelist,
  activeOrg,
  enums,
  bulletinBoard
}
